export const recentItems = ({ listsReducer }) => listsReducer.recentItems;
